// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto', 'Roboto Fallback'"},"className":"__className_0250f4"};